export default __webpack_public_path__ + "static/media/heroku.33e684f8.png";